import { Modal } from '@bp/ui-components';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AppStatusResponse, SubstitionAppSetupForm } from '../forms/SubstitionAppSetupForm';

type SubstitionAppSetupModalProps = {
  isOpen: boolean;
  appStatus?: AppStatusResponse;
  onClose: () => void;
};

export const SubstitionAppSetupModal = ({ isOpen, appStatus, onClose }: SubstitionAppSetupModalProps) => {
  const { t } = useTranslation();

  const [loading, setLoading] = useState<boolean>(false);

  return (
    <Modal title={t('substitutions.app.editSetup')} isOpen={isOpen} onRequestClose={onClose} loading={loading}>
      <SubstitionAppSetupForm appStatus={appStatus} onClose={onClose} onLoad={setLoading} />
    </Modal>
  );
};
